'use client';

import OpeningHoursFlyoutInfo from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/OpeningHoursFlyoutInfo";
import EntranceFeeFlyoutInfo from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/EntranceFeeFlyoutInfo";
import EventsFlyoutInfo from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/EventsFlyoutInfo";
import EventLocationsFlyoutInfo
    from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/EventLocationsFlyoutInfo";
import ApproachFlyoutInfo from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/approach/ApproachFlyoutInfo";
import A11yFlyoutInfo from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/A11yFlyoutInfo";
import NewsletterFlyoutInfo from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/newsletter/NewsletterFlyoutInfo";
import ContactFlyoutInfo from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/ContactFlyoutInfo";
import React from "react";
import { SubmenuItem } from "@/app/features/sites/header/types/menu-items";

function FlyoutView({ activeMenuId }: { activeMenuId: SubmenuItem['id'] | null }) {
    if (activeMenuId === null) return null;
    return <FlyoutContent flyoutId={activeMenuId} />;
}

function FlyoutContent({ flyoutId }: { flyoutId: SubmenuItem['id'] }) {
    switch (flyoutId) {
        case 'opening-hours': return <OpeningHoursFlyoutInfo />
        case 'entrance-fee': return <EntranceFeeFlyoutInfo />
        case 'events': return <EventsFlyoutInfo />
        case 'event-locations': return <EventLocationsFlyoutInfo />
        case 'approach': return <ApproachFlyoutInfo />
        case 'a11y': return <A11yFlyoutInfo />
        case 'newsletter': return <NewsletterFlyoutInfo />
        case 'contact': return <ContactFlyoutInfo />
    }
}

export default React.memo(FlyoutView);
